import { BaseApiRequest } from "../common/base-api-request"
import { Http } from "../common/http"
import { HttpResponse } from "../common/models/response"
import { MutableUserFields } from "./models/mutable-user-fields"
import { UserGetResponse } from "./models/user-get-response"
import { UserModel } from "./models/user-model"

export class User extends BaseApiRequest {

	public async get(userId: String): Promise<UserModel> {
		const response = await Http.send(this.defaultUrl + `/${userId}`)

		if (!response.id) {
			throw new Error(`${(response as HttpResponse).statusCode} ${(response as HttpResponse).message}`)
		}
		return response
	}

	public getAll(
		limit?: number,
		page?: number,
		order?: string,
		orderBy?: string,
		searchBy?: string,
		searchString?: string
	): Promise<UserGetResponse> {
		let params = '?limit=20'
		if (limit) {
			params = `?limit=${limit}`
		}
		if (page) {
			params += `&page=${page}`
		}
		if (order) {
			params += `&order=${order}`
		}
		if (orderBy) {
			params += `&orderBy=${orderBy}`
		}
		if (searchBy) {
			params += `&searchBy=${searchBy}`
		}
		if (searchString) {
			params += `&searchString=${searchString}`
		}
		return Http.send(this.defaultUrl + params)
	}

	public getCurrentUser(): Promise<UserModel> {
		return Http.send(this.defaultUrl + `/current`)
	}

	public create(user: MutableUserFields): Promise<UserModel> {
		return Http.send(this.defaultUrl, "POST", user)
	}

	public update(userId: string, user: MutableUserFields): Promise<MutableUserFields> {
		return Http.send(this.defaultUrl + `/${userId}`, "PATCH", user)
	}

	public activateUser(userId: string, token: string) {
		const body = { userId, token }
		return Http.send(this.defaultUrl + `/activate`, "POST", body)
	}

	public delete(userId: string) {
		return Http.send(this.defaultUrl + `/${userId}`, "DELETE")
	}

	public changePassword(oldPassword: string, newPassword: string) {
		const body = { oldPassword, newPassword }
		return Http.send(this.defaultUrl + `/change-password`, "POST", body)
	}

	public changePasswordToRandomAndMailToUser(userId: string) {
		return Http.send(this.defaultUrl + `/change-password/${userId}`, "POST")
	}

	public resetPassword(email: string, registrationCode: string) {
		const body = { email, registrationCode }
		return Http.send(this.defaultUrl + `/password-reset`, "POST")
	}

	public setNewPassword(userId: string, token: string, newPassword: string) {
		const body = { newPassword }
		return Http.send(this.defaultUrl + `/${userId}/password-reset/${token}`, "POST", body)
	}

	public sendVerificationMail(userId: string) {
		return Http.send(this.defaultUrl + `/${userId}/verification-mail`, "POST")
	}

	public banUserById(userId: string) {
		return Http.send(this.defaultUrl + `/${userId}/ban`, "POST")
	}

	public unbanUserById(userId: string) {
		return Http.send(this.defaultUrl + `/${userId}/unban`, "POST")
	}

	public setUserRoleById(userId: string, roleId: string) {
		const requestBody = { roleId }
		return Http.send(this.defaultUrl + `/${userId}/role`, "POST", requestBody)
	}
}
